module.exports = "/assets/images/099840de013ab5cd2ee5d09da8cbaa09.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg
// module id = PTng
// module chunks = 0